import React, {useEffect, useState } from "react";
import {Box} from "@mui/material";
import MyLabel from "../../../components/myLabel";
import Modal from '@mui/material/Modal';
import MyImage from "../../../components/myImage";
import CloseIcon from '@mui/icons-material/Close';
import MyLoading from "../../../components/myLoading";
import { usePDF } from 'react-to-pdf';
import MyButton from "../../../components/myButton";

const QrcodeModal = ({open, handleClose, idlocal, nomeLocal, states}) => {

    const [imprimindo, setImprimindo] = useState(false)    
    const { toPDF, targetRef } = usePDF({filename:  `qrcode_localTarefa_${idlocal}.pdf`});        

    useEffect(()=>{
        if (states && idlocal && idlocal !== ''){
            states.qrcodeLocalTarefa.set(idlocal)
        }
    }, [nomeLocal])

    useEffect(()=>{
        let imprimir = async ()=>{
                await toPDF()
                setImprimindo(false)
           }

        if (imprimindo){
            imprimir()
        }
    }, [imprimindo]) 

    const handlerImprimir = async ()=>{
        setImprimindo(true)
    }    
  

    return (
        <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            >
            <Box sx={ {       
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: '300px',
                height: '375px',
                bgcolor: 'background.paper',
                border: '2px solid #000',
                boxShadow: 24,
                borderRadius:2,
                p: 2,}
                }>
                    <MyLoading render={states.submit.value || imprimindo}/>            
                    <Box sx={{display:'flex', justifyContent:'space-between'}}>
                        <MyButton color='primary' onClick={handlerImprimir} variant='contained' text='Imprimir' sx={{marginRight:'10px'}}/>                        
                        <CloseIcon onClick={handleClose}></CloseIcon>
                    </Box>
                    <Box ref={targetRef} sx={{justifyContent:'center',  padding: 1}}>
                        <Box sx={{justifyContent:'center', border: '4px solid black',  padding: 2}}>
                            <Box sx={{width:'100%', display:'flex', justifyContent:'center', aligItems:'center'}}> {/* imagem do Qrcode */}
                                {states.qrcodeLocalTarefa?.value ? 
                                    <MyImage sx={{height:'100%', width:'200px'}} src={states.qrcodeLocalTarefa?.value} alt="QR Code"/>
                                    : 
                                    <Box sx={{height:'100%', width:'200px'}}/>
                                }                    
                            </Box>
                            <Box sx={{width:'100%',marginLeft:2, display:'flex', justifyContent:'center', aligItems:'center'}}>
                                <MyLabel text={`${idlocal} - ${nomeLocal}`} />
                            </Box>
                        </Box>
                    </Box>
            </Box>
        </Modal> 
    )
}
export default QrcodeModal;